module.exports = __webpack_public_path__ + "static/media/about-us-books.7b7579d1.png";